<svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <rect x="12" y="16" width="5" height="16" rx="2" transform="rotate(180 12 16)" fill="currentColor" />
    <path
      d="M19 14C19 15.1046 18.1046 16 17 16L16 16C14.8954 16 14 15.1046 14 14L14 2C14 0.895429 14.8954 -8.00104e-07 16 -1.09807e-06L17 -1.36783e-06C18.1046 -1.6658e-06 19 0.895429 19 2L19 14Z"
      fill="currentColor" />
    <path
      d="M5 14C5 15.1046 4.10457 16 3 16L2 16C0.895431 16 4.54967e-07 15.1046 4.27989e-07 14L1.34897e-07 2C1.07919e-07 0.895429 0.895431 -8.00104e-07 2 -1.09807e-06L3 -1.36783e-06C4.10457 -1.6658e-06 5 0.895429 5 2L5 14Z"
      fill="currentColor" />
  </g>
</svg>
